import { MetadataEnumTypeData } from '../metadata/entity/decorators/model/metadata.entity.field.data';
import { SystemWorkOrderStatus } from '../entities/job/system.workorder.status';
import { WorkOrderStatusUtility } from './workorder.status.utility';

const STATUS_ORDER: SystemWorkOrderStatus[] = [
    SystemWorkOrderStatus.Open,
    SystemWorkOrderStatus.InProgress,
    SystemWorkOrderStatus.OnHold,
    SystemWorkOrderStatus.Completed,
    SystemWorkOrderStatus.Finalised,
    SystemWorkOrderStatus.Closed,
];

export function getJobStatusEnumMetadata(): MetadataEnumTypeData[] {

    return STATUS_ORDER.map(status => ({
        key: status,
        value: status,
        color: WorkOrderStatusUtility.getSystemColor(status),
    }));
}
